import { createSlice } from '@reduxjs/toolkit';

import { IConfigData } from 'shared/types/config';

const initialState: IConfigData = {
  appHost: '',
  cianHost: '',
  avatarHost: '',
  apiKey: '',
  suggestApiKey: '',
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {},
  selectors: {
    selectConfig: state => state,
  },
});

export const {
  reducer: configReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: {},
  selectors: { selectConfig },
} = configSlice;
